module.exports = __webpack_public_path__ + "resources/e247a5dbbbbcee4258c60ef6bb0b4ba2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundsupermove7.png
// module id = 201
// module chunks = 0